import { TLearningCurveActions } from './learning-curve.actions';
import { TLearningCurveState, TLearningCurveInfoActionType } from './learning-curve.models';
import { LEARNING_CURVE_ITEMS_PER_PAGE_LIST } from './learning-curve.facade';

export const initialState: TLearningCurveState = {
  learningCurveInfo: null,
  userPaginationOption: {
    pageNo: 1,
    pageSize: LEARNING_CURVE_ITEMS_PER_PAGE_LIST[0],
  },
};

export function learningCurveReducer(state = initialState, action: TLearningCurveActions): TLearningCurveState {
  switch (action.type) {
    case TLearningCurveInfoActionType.GetLearningCurveInfo:
      return {
        ...state,
        learningCurveInfo: null,
      };
    case TLearningCurveInfoActionType.GetLearningCurveInfoSuccess:
      return {
        ...state,
        learningCurveInfo: action.learningCurveRes,
      };
    case TLearningCurveInfoActionType.SetUserPaginationOption:
      return {
        ...state,
        userPaginationOption: action.userPaginationOption,
      };
    default:
      return state;
  }
}
